import { render } from "./LiveFeed.vue?vue&type=template&id=7c326515&scoped=true"
import script from "./LiveFeed.vue?vue&type=script&lang=js"
export * from "./LiveFeed.vue?vue&type=script&lang=js"

import "./LiveFeed.vue?vue&type=style&index=0&id=7c326515&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c326515"],['__file',"resources/js/components/LiveFeed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c326515"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c326515', __exports__)) {
    api.reload('7c326515', __exports__)
  }
  
  module.hot.accept("./LiveFeed.vue?vue&type=template&id=7c326515&scoped=true", () => {
    api.rerender('7c326515', render)
  })

}


export default __exports__